import React, { useEffect, useRef } from 'react';
import { Alert, AlertDescription, AlertIcon } from '@chakra-ui/react';

import { t } from '#i18n';

const TEN_SECONDS = 15_000;

export const SyncingInstallationAlert = ({
  installation,
  margin,
  variant,
  refetchInstallation,
  onStatusActive,
}) => {
  const intervalRef = useRef(null);
  const { status } = installation || {};

  useEffect(() => {
    if (status === 'SYNCING') {
      intervalRef.current = setInterval(() => refetchInstallation(), TEN_SECONDS);
    } else {
      clearInterval(intervalRef.current);

      if (status === 'ACTIVE' && onStatusActive) {
        onStatusActive();
      }
    }

    return () => clearInterval(intervalRef.current);
  }, [status, refetchInstallation, onStatusActive]);

  if (status !== 'SYNCING') {
    return null;
  }

  return (
    <Alert
      status="info"
      borderRadius="md"
      fontSize="sm"
      margin={margin}
      variant={variant}
    >
      <AlertIcon />
      <AlertDescription>
        {t('alerts.syncingInstallation.message')}
      </AlertDescription>
    </Alert>
  );
};
